import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr } from '@ember-data/model';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
let LogModel = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = attr('string'), _dec7 = attr('string'), _dec8 = attr('boolean', {
  defaultValue: false
}), _class = class LogModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "date", _descriptor, this);
    _initializerDefineProperty(this, "operation", _descriptor2, this);
    _initializerDefineProperty(this, "executed_by", _descriptor3, this);
    _initializerDefineProperty(this, "executed_by_id", _descriptor4, this);
    _initializerDefineProperty(this, "model", _descriptor5, this);
    _initializerDefineProperty(this, "model_name", _descriptor6, this);
    _initializerDefineProperty(this, "model_id", _descriptor7, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor8, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "date", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "operation", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "executed_by", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "executed_by_id", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "model", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "model_name", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "model_id", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { LogModel as default };
//# sourceMappingURL=log.js.map
